import React, { useEffect, useRef, useState } from 'react'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    IconButton,
    Typography,
    Box,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from '../../component/addCategoryForm/addCategoryForm.module.css';
import styless from '../../component/scheduleComps/scheduleList/partList.module.css';
import { AddCircle, Closecircle, UploadImg } from '../../Svg';
import stylesp from './prod.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { addTopcategoriesThunk, getTopCategoriesThunk } from '../../redux/appearanceSlice';
import { toast } from 'react-toastify';
import api from '../../utils/api';


const FeaturedBrand = ({ Accordions, handleChange, expanded }) => {
    const [selectedCategories, setSelectedCategories] = useState([])
    const [category, setAllManufacturer] = useState([]);
    const [refresh, setRefresh] = useState(false)
    const [categories, setCategories] = useState({
        data: [

        ],
        loading: false
    })

    const dispatch = useDispatch()


    useEffect(() => {
        getAllManufacturer()
    }, [])

    useEffect(() => {
        getFeaturedBrand()
    }, [refresh])

    const getAllManufacturer = async () => {
        try {
            const { data, status } = await api.getAllWebManufacturer();

            if (status === 200) {
                console.log("data----", data)
                setAllManufacturer(data.data)
            }
        } catch (err) {
            console.log(err);
        }
    }

    const getFeaturedBrand = async () => {
        try {
            const { data, status } = await api.getFeaturedBrand();

            if (status === 200) {
                setCategories(data);
            }
        } catch (err) {
            console.log(err);
        }
    }


    const [isOpen, setIsOpen] = useState(false);
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const [filteredData, setFilteredData] = useState(null);


    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const closeDropdown = () => {
        setIsOpen(false);
        setSearchTerm('');
        setFilteredData(null);
    };

    const handleToggleDropdown = () => {
        const newState = !isOpen;
        setIsOpen(newState);
        if (!newState) {
            closeDropdown();
        }
    };

    const handleSearchChange = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        const filtered = term === ''
            ? null
            : category?.filter(customer =>
                customer?.name?.toLowerCase().includes(term.toLowerCase())
            );
        setFilteredData(filtered);
    };


    const handleSelectionChange = (cat) => {
        setSelectedCategories((prevSelected) => {
            const isSelected = prevSelected?.some((item) => item?._id === cat?._id);
            if (isSelected) {
                return prevSelected?.filter((item) => item?._id !== cat?._id);
            }
            else {
                return [...prevSelected, cat];
            }
        });
    };

    const addCategories = async () => {
        try {
            setCategories((prev) => {
                return {
                    ...prev,
                    loading: true
                }
            })
            const { data, status } = await api.addFeaturedBrand({
                brand: selectedCategories
            })

            if (status === 200) {
                toast.success("Brand added successfully")
                setRefresh(true);
            }
        } catch (err) {
            toast.error("Some error occured!")
        } finally {
            setCategories((prev) => {
                return {
                    ...prev,
                    loading: false
                }
            })
        }
    }


    useEffect(() => {
        setSelectedCategories(categories?.data?.brand || [])
    }, [categories])

    return (
        <Accordions sx={{ marginBottom: "20px" }}
            expanded={expanded === "featuredBrand"}
            onChange={handleChange("featuredBrand")}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography sx={{
                    fontSize: "16px",
                    color: "#1D1F2C",
                }}>Featured Brand</Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ background: '#F0F1F3B2', margin: "0px 20px 20px 20px" }}>
                <div>
                    <label className={styles.addCatLabel}>
                        Brands
                    </label>

                    <div className={stylesp.customSelect} ref={dropdownRef}>
                        <div
                            className={styles.addCatSelect} style={{ paddingTop: "11px" }}
                            onClick={handleToggleDropdown}
                        >
                            Select
                        </div>
                        {
                            isOpen &&
                            <div className={stylesp.dropdownContent}>
                                <div style={{}}>
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            boxSizing: 'border-box',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px'
                                        }}
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div style={{ maxHeight: "140px", overflowY: "scroll" }}>
                                    {(filteredData || category)?.map((cat) => (

                                        <label
                                            key={cat?._id}
                                            className={stylesp.dropdownItem}
                                        >
                                            {cat?.name}
                                            <input
                                                type="checkbox"
                                                checked={selectedCategories?.some((item) => item?._id === cat?._id)}
                                                onChange={() => handleSelectionChange(cat)}
                                            />
                                        </label>
                                    ))}


                                </div>
                                <div style={{ display: 'flex', justifyContent: "center", width: "100%" }}>
                                    <button
                                        type="submit"
                                        className={stylesp.loginButton}
                                        style={{ borderRadius: "0px" }}
                                        onClick={toggleDropdown}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        }
                    </div>


                    <p className={styles.addCatLabel} style={{ margin: "15px 0" }}>You can select brand that you want to show.</p>

                    <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 10, gap: 10, }}>
                        {
                            selectedCategories?.map((i) => (
                                <div className={styles.selectedname}>
                                    {i?.name}
                                    <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSelectionChange(i)}>
                                        {Closecircle()}

                                    </div>
                                </div>
                            ))
                        }
                    </div>

                    <div style={{ margin: "10px 0px 10px 0px", display: 'flex', justifyContent: 'flex-end', gap: '20px' }}>
                        <button className={styless.cancelBtn}>Cancel</button>
                        <button className={styless.submitBtn} onClick={addCategories} disabled={categories?.loading}>{categories?.loading ? 'please wait...' : 'Save changes'}</button>
                    </div>
                </div>
            </AccordionDetails>
        </Accordions>
    )
}

export default FeaturedBrand